// src/resources/country_cpm_floors/CountryCpmList.tsx
import { List, Datagrid, TextField, NumberField, EditButton } from 'react-admin';

export const CountryCpmList = () => (
  <List
    resource="country_cpm_floors"
    sort={{ field: 'country_name', order: 'ASC' }} // initial sort
    perPage={25}
  >
    <Datagrid rowClick="edit">
      <TextField source="country_code" sortable />
      <TextField source="country_name" sortable />
      <NumberField source="cpm_floor_video" sortable />
      <NumberField source="rev_share_base_usd" sortable />
      <NumberField source="rev_share_boosted_usd" sortable />
      <EditButton />
    </Datagrid>
  </List>
);